// generate ExerciseCategoriesTable component like AppFileTable but use ExerciseCategory model
import Container from "../../../../components/container";
import { ExerciseCategory } from "../../../../models";
import { ExerciseViewModel } from "../../../../viewModels";
import { UpdateButton, DeleteButton } from "./buttons";

export default function ExercisesTable({
  items,
}: {
  items: ExerciseViewModel[];
}) {
  return (
    <Container className="max-w-6xl  text-left">
      <table className="min-w-full text-gray-900 text-left ">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th scope="col" className="px-6 py-3">
              Name
            </th>
            <th scope="col" className="px-6 py-3">
              Category
            </th>
            <th scope="col" className="px-6 py-3">
              Load Type
            </th>            
            <th scope="col" className="px-6 py-3">
              Active
            </th>
             <th scope="col" className="px-6 py-3">
              Free
            </th>
            <th scope="col" className="px-6 py-3">
              <span className="sr-only">Edit</span>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {items.map((item) => (
            <tr key={item.id}  className="border-b">
              <td className="whitespace-nowrap px-6 py-3">{item.name}</td>
              <td className="whitespace-nowrap px-6 py-3">
                {item.exerciseCategory?.name}
              </td>
              <td className="whitespace-nowrap px-6 py-3">
                {item.exerciseLoadType?.name}
              </td>
              <td className="whitespace-nowrap px-6 py-3">
                {item.isActive ? "Yes" : "No"}
              </td>
              <td className="whitespace-nowrap px-6 py-3">
                {item.isFree ? "Yes" : "No"}
              </td>
              <td className="px-6 py-4">
                {item.id ? (
                  <div className="flex flex-1 items-center justify-end gap-2">
                    <UpdateButton id={item.id} />
                    <DeleteButton id={item.id} />
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}
